export const tokens = {
    classNames: {
        slateEditor: 'slate-editor',
        fixedToolbar: 'fixed-toolbar'
    }
};
